
export function isActionContentObject(obj: any): boolean {
  return obj && typeof obj === 'object';
}
